/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  useRef,
  useEffect,
  useLayoutEffect,
  useContext,
} from 'react';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';
import ColorPicker from 'components/UI/ColorPicker';
import EditorBtn from 'components/UI/EditorBtn';
import DownloadSVG from './DownloadSVG';
import LoadingSpinner from 'components/UI/LoadingSpinner';
import { ChameleonsLibraryContext } from './ChameleonsLibrary';
import { useSelector } from 'react-redux';
import ThumbnailContainer from '../ThumbnailContainer';

const { lPink, lGrey0 } = colors;

let defaultColor = '#61CECE';

interface IChameleonsImagePreview {
  src: string;
  cachedSVGs?: any;
  label?: string;
  selected: boolean;
  onClick: (src: string) => void;
  color: string;
  getRef?: () => void;
}

interface ISVG {
  src: string;
  label?: string;
  cachedSVGs?: any;
  color?: string;
  getRef?: (ref: any) => void;
}

const SVG = ({ src, label, cachedSVGs, color, getRef }: ISVG) => {
  const { cache, updateCache } = useContext(ChameleonsLibraryContext);

  const [svg, setSvg] = useState(cache[src]);
  const [changeColorElements, setChangeColorElements] = useState([] as any);

  const mounted = useRef<any>(true);
  const svgDOM = useRef<any>(null);

  const fill = useSelector((state: any) => {
    return state.theme.recoloredChameleonImages[src] || defaultColor;
  });

  useEffect(() => {
    if (cache[src]) {
      setSvg(cache[src]);
      return;
    }

    //
    fetch(src)
      .then(r => r.text())
      .then(r => {
        mounted.current && setSvg(updateCache(src, r));
      });
  }, [src]);

  useEffect(() => {
    if (!svgDOM.current) return;

    const SVG = svgDOM.current.querySelector('svg');

    if (SVG) {
      SVG.setAttribute('width', '100%');
      SVG.setAttribute('height', '100%');
    }

    const changeColorElements = Array.from(
      svgDOM.current.querySelectorAll('*')
    ).filter((elem: any) => elem.id === 'Change_colour');

    mounted.current && setChangeColorElements(changeColorElements);
  }, [svg]);

  useEffect(() => {
    if (!svgDOM.current) return;

    changeColorElements.forEach((elem: any) => {
      Array.from(elem.querySelectorAll('*')).forEach(
        (childElem: any) => (childElem.style.fill = fill)
      );
    });
  });

  useEffect(() => () => { mounted.current = false }, []);

  return svg ? (
    <div
      ref={svgDOM}
      className="fader_-5s"
      css={css`
        width: 100%;
        height: 100%;
      `}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  ) : (
      <LoadingSpinner />
    );
};

const ChameleonsImagePreview = ({
  src,
  label,
  selected,
  onClick,
  color,
}: IChameleonsImagePreview) => {

  return (
    <ThumbnailContainer
      selected={selected}
      label={label}
      onClick={() => onClick(src)}
    >
      <SVG src={src} color={color} />
    </ThumbnailContainer>
  );
};

export default ChameleonsImagePreview;
export { SVG };
